(() => {
  const button = document.querySelector('[data-show-ip]');
  const target = document.querySelector('[data-public-ip]');
  if (!button || !target) return;
  button.addEventListener('click', async () => {
    button.disabled = true;
    target.textContent = target.dataset.loading;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 5000);
    try {
      const response = await fetch('https://api.ipify.org?format=json', {
        signal: controller.signal, cache: 'no-store', credentials: 'omit', referrerPolicy: 'no-referrer'
      });
      if (!response.ok) throw new Error('lookup');
      const data = await response.json();
      if (typeof data.ip !== 'string' || !/^\d{1,3}(\.\d{1,3}){3}$/.test(data.ip) || data.ip.split('.').some(part => Number(part) > 255)) throw new Error('address');
      target.textContent = data.ip;
    } catch {
      target.textContent = target.dataset.unavailable;
    } finally {
      clearTimeout(timer);
      button.disabled = false;
    }
  });
})();